import { queryOptions } from "@tanstack/react-query";
import type { BootstrapData } from "~/app/store/bffApi";
import { fetchPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";

export const bootstrapQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.bootstrap(),
    queryFn: () => fetchPageData<BootstrapData>("/page-data/bootstrap"),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 1,
  });
